import styled from 'styled-components';

// Keep the backdrop in the same mount/unmount commit as the modal.
export const ResourceModalHandlerBackground = styled.div.attrs({
  'data-id': 'resource-modal-handler-background',
})`
  width: 100% !important;
  height: 100% !important;

  position: fixed;
  top: 0;
  left: 0;

  background: rgba(0, 0, 0, 0.3);

  z-index: 9999998;
`;
